import { all, put, takeEvery } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { postman } from '../utils/postman';

//*  TYPES  *//
const GET_HISTORY_REQUEST = 'GET_HISTORY_REQUEST';
const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS';
const GET_HISTORY_ERROR = 'GET_HISTORY_ERROR';

const CLEAR_HISTORY = 'CLEAR_HISTORY';
const DEFAULT_STATE = 'DEFAULT_STATE';

//*  INITIAL STATE  *//

const initial = {
    history: {
        data: [],
        progress: false,
    },
    comments: {
        data: [],
        progress: false,
    },
};

//*  REDUCER  *//

export default (state = initial, { type, payload }) => {
    switch (type) {
        case GET_HISTORY_REQUEST: {
            const { historyType = 'history' } = payload;

            return {
                ...state,
                [historyType]: {
                    ...state[historyType],
                    progress: true,
                },
            };
        }

        case GET_HISTORY_SUCCESS: {
            const { historyType = 'history', data } = payload;

            return {
                ...state,
                [historyType]: {
                    progress: false,
                    data,
                },
            };
        }

        case GET_HISTORY_ERROR: {
            const { historyType = 'history' } = payload;

            return {
                ...state,
                [historyType]: {
                    progress: false,
                    data: [],
                },
            };
        }

        case CLEAR_HISTORY:
            return initial;

        default:
            return state;
    }
};

//*  ACTION CREATORS  *//

export const getHistoryRequest = payload => {
    return {
        type: GET_HISTORY_REQUEST,
        payload,
    };
};

export const clearHistory = () => {
    return {
        type: CLEAR_HISTORY,
    };
};

//*  SELECTORS *//

const stateSelector = state => state.historyList;

export const historySelector = (historyType = 'history') =>
    createSelector(
        stateSelector,
        state => state?.[historyType]?.data ?? []
    );

export const progressSelector = (historyType = 'history') =>
    createSelector(
        stateSelector,
        state => state?.[historyType]?.progress ?? false
    );

//*  SAGA  *//


function* getHistorySaga({ payload }) {
    try {
        const { id, ids, historyType = 'history' } = payload;

        let url;
        if (ids && ids.length) {
            const params = ids.map(i => `ids=${i}`).join('&');
            url = `/history/items?${params}`;
        } else if (historyType === 'comments') {
            url = `/commentsHistory/${id}`;
        } else {
            url = `/history/${id}`;
        }

        const result = yield postman.get(url);

        yield put({
            type: GET_HISTORY_SUCCESS,
            payload: {
                historyType,
                data: result.entries,
            },
        });
    } catch (e) {
        yield put({
            type: GET_HISTORY_ERROR,
            payload: {
                historyType: payload.historyType,
            },
        });
    }
}

export function* saga() {
    yield all([takeEvery(GET_HISTORY_REQUEST, getHistorySaga)]);
}
